import { Box } from "@mui/material";

function FlagFrame({ children, ...props }) {
  return (
    <Box
      component="svg"
      viewBox="0 0 24 16"
      sx={{ width: 22, height: 15, borderRadius: "3px", display: "block", boxShadow: "0 0 0 1px rgba(0,0,0,0.08)", overflow: "hidden" }}
      {...props}
    >
      {children}
    </Box>
  );
}

export function FlagEN(props) {
  return (
    <FlagFrame {...props}>
      <rect width="24" height="16" fill="#b22234" />
      <rect width="24" height="1.23" y="1.23" fill="#fff" />
      <rect width="24" height="1.23" y="3.69" fill="#fff" />
      <rect width="24" height="1.23" y="6.15" fill="#fff" />
      <rect width="24" height="1.23" y="8.62" fill="#fff" />
      <rect width="24" height="1.23" y="11.08" fill="#fff" />
      <rect width="24" height="1.23" y="13.54" fill="#fff" />
      <rect width="9.6" height="8.62" fill="#3c3b6e" />
    </FlagFrame>
  );
}

export function FlagES(props) {
  return (
    <FlagFrame {...props}>
      <rect width="24" height="16" fill="#aa151b" />
      <rect width="24" height="8" y="4" fill="#f1bf00" />
    </FlagFrame>
  );
}

export function FlagMX(props) {
  return (
    <FlagFrame {...props}>
      <rect width="8" height="16" fill="#006847" />
      <rect width="8" height="16" x="8" fill="#fff" />
      <rect width="8" height="16" x="16" fill="#ce1126" />
    </FlagFrame>
  );
}

export function FlagIT(props) {
  return (
    <FlagFrame {...props}>
      <rect width="8" height="16" fill="#009246" />
      <rect width="8" height="16" x="8" fill="#fff" />
      <rect width="8" height="16" x="16" fill="#ce2b37" />
    </FlagFrame>
  );
}

export function FlagDE(props) {
  return (
    <FlagFrame {...props}>
      <rect width="24" height="5.33" fill="#000" />
      <rect width="24" height="5.33" y="5.33" fill="#dd0000" />
      <rect width="24" height="5.34" y="10.66" fill="#ffce00" />
    </FlagFrame>
  );
}

export function FlagPL(props) {
  return (
    <FlagFrame {...props}>
      <rect width="24" height="8" fill="#fff" />
      <rect width="24" height="8" y="8" fill="#dc143c" />
    </FlagFrame>
  );
}

export function FlagBR(props) {
  return (
    <FlagFrame {...props}>
      <rect width="24" height="16" fill="#009b3a" />
      <polygon points="12,2 21,8 12,14 3,8" fill="#ffdf00" />
      <circle cx="12" cy="8" r="2.4" fill="#002776" />
    </FlagFrame>
  );
}

export function FlagPT(props) {
  return (
    <FlagFrame {...props}>
      <rect width="9.6" height="16" fill="#006600" />
      <rect width="14.4" height="16" x="9.6" fill="#ff0000" />
    </FlagFrame>
  );
}

export function FlagRU(props) {
  return (
    <FlagFrame {...props}>
      <rect width="24" height="16" fill="#fff" />
      <rect width="24" height="10.66" y="5.34" fill="#0039a6" />
      <rect width="24" height="5.33" y="10.67" fill="#d52b1e" />
    </FlagFrame>
  );
}

export function FlagUA(props) {
  return (
    <FlagFrame {...props}>
      <rect width="24" height="8" fill="#0057b7" />
      <rect width="24" height="8" y="8" fill="#ffd700" />
    </FlagFrame>
  );
}

export function FlagFR(props) {
  return (
    <FlagFrame {...props}>
      <rect width="8" height="16" fill="#0055a4" />
      <rect width="8" height="16" x="8" fill="#fff" />
      <rect width="8" height="16" x="16" fill="#ef4135" />
    </FlagFrame>
  );
}

export const FLAG_BY_CODE = {
  en: FlagEN,
  "es-ES": FlagES,
  "es-MX": FlagMX,
  it: FlagIT,
  de: FlagDE,
  pl: FlagPL,
  "pt-BR": FlagBR,
  "pt-PT": FlagPT,
  ru: FlagRU,
  uk: FlagUA,
  fr: FlagFR,
};
